import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import MemberIconNew from "../member-icon-new/member-icon-new";
import MemberIconMultipleOwner from "../member-icon-new/member-icon-multi-owner";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import GroupIcon from '../../assets/icons/Icons - Groups.svg';
import PropTypes from "prop-types";
import { unavailableReason } from "../TaskAssignMember/TaskAssignMemberHelper";
import "./member-dropdown-new.scss";

const MemberDropdownNew = ({
  index,
  member,
  type,
  filter,
  toggleRow,
  selectedMembers,
  rowFilter,
  taskType,
  projects,
  isGroup,
  classNameAddition,
  isGroupOwner = false,
  isUserAdminComponent = false,
  isGroupIcon,
  isMultiOwner = true
}) => {
  const [className] = useState(classNameAddition ? classNameAddition : '');
  const [checked, setChecked] = useState(false);
  const [name, setName] = useState((isGroupOwner||isUserAdminComponent) ? member?.Name :member?.User?.Name ||'');
  const IsMultiOwner = isMultiOwner;
  const TaskIcon = IsMultiOwner ? MemberIconMultipleOwner : MemberIconNew;
  // Archived/moved assignee (TAD-5898): grey the row. The flag is only ever set
  // on task-assignee payloads, so other consumers are unaffected.
  const isArchived =
    member?.User?.Archived === true || member?.User?.Deleted === true || member?.Archived === true;

  useEffect(() => {
    if(isGroupOwner) return;

    const propertyToCheck = isUserAdminComponent ? 'Id' : 'UserId';
    const isMemberSelected = selectedMembers.some(selectedMember => selectedMember[propertyToCheck] === member[propertyToCheck]);
    setChecked(isMemberSelected);

    let newName = member?.User?.Name ?? member?.Name;
    if (newName?.length > 30) {
      newName = `${newName.slice(0, 27)}...`;
    }
    setName(newName);
  }, [member, type, filter, toggleRow, selectedMembers, rowFilter, taskType, isGroupOwner, isUserAdminComponent]);


  const toggleChecked = (e) => {
    toggleRow(member, !checked);
    setChecked(!checked);
  };

  const overlayString = (showGroupName) => {
    const { GroupId, strRole, StrRole, User = {}, emailID, IsGroup } = member;
    const email = User.Email || emailID || member?.Email;
    const role = strRole || StrRole;

    if (GroupId) {
      return groupHover();
    }
    else if (IsGroup && !showGroupName) {
      return groupHoverNew();
    }

    if (type === "creator" && !role) {
      return name;
    }

    let result = name;

    if (role) {
      result += ` (${role})`;
    }

    if (!projects && email) {
      result += ` - ${email}`;
    }

    return result;
  }

  const groupHover = () => {
    let hoverStr = member?.GroupMembers?.map(groupMember  => {
      return(
        <div className="whiteText">
            {groupMember?.User?.Name}
        </div>

      )     
    });
    return hoverStr;
  }

  const groupHoverNew = () => {
    let hoverStr = member?.User?.GroupMembers?.map(groupMember  => {
      return(
        <div className="whiteText" key={groupMember?.User?.Id}>
            {groupMember?.User?.Name}
        </div>

      )     
    });
    return hoverStr;
  }

  const formatName = () => {
    if (member.IsOwner) type = "user";
    const maxLengths = {
      user: 6,
      creator: 5,
      default: 12,
    };

    const maxLength = filter ? maxLengths.default : maxLengths[type] || maxLengths.default;

    return name.length <= maxLength ? name : `${name.substring(0, maxLength)}...`;
  };

  // Archived rows explain themselves; an empty hover (archived group whose
  // roster was fully revoked) must not render a blank tooltip, which shows up
  // as a black dot (QA feedback, TAD-5898).
  const archivedReason = isArchived
    ? unavailableReason({ Archived: true, Deleted: member?.User?.Deleted === true, IsGroup: Boolean(member.GroupId || member.IsGroup) })
    : null;

  const wrapWithTooltip = (content, children) => {
    const hasContent = Array.isArray(content) ? content.length > 0 : Boolean(content);
    if (!hasContent) {
      return children;
    }

    return (
      <OverlayTrigger placement="right" delay={{ show: 150, hide: 150 }} trigger={['hover', 'focus']} overlay={
        <Tooltip id={`tooltip-${index}`} >
          {content}
        </Tooltip>
      }>
        {children}
      </OverlayTrigger>
    );
  };

  return (
    <div >
      
        <Form.Check className={`${!projects ? 'member-dropdown-row' : 'member-dropdown-row-small'}${className}`}>
          {filter ? (
            <Form.Check.Input
              className={`member-dropdown-row-checkbox${className}`}
              type="checkbox"
              checked={checked}
              disabled={!filter}
              onClick={(e) => toggleChecked(e)}
            />
          ) : (
            <></>
          )}

            <div className='member-name-icon-container'>
              <div className={`member-dropdown-row-user-icon${className}`}>
                {
                  <TaskIcon
                    type={type}
                    member={member}
                    isGroup={isGroupOwner}
                    isGroupIcon={isGroupIcon}
                  />
                }
              </div>

              <div className={`${!projects ? 'member-name-email-department-container-new' : 'member-name-email-department-container'}`}>
            {wrapWithTooltip(
              archivedReason ?? overlayString(true),
              <div className={`member-dropdown-row-name${className}${isArchived ? " member-dropdown-row-archived" : ""}`}>
                {formatName()} {((type === "user" || member.IsOwner) && !filter) ? "(Owner)" : ""} {(type === "creator" && !filter) ? "(Creator)" : ""}
              </div>
            )}
                {wrapWithTooltip(
                  archivedReason ?? overlayString(),
                  <div className="member-dropdown-row-user-icon">
                    {(member.GroupId || member.IsGroup) ? <img className='group-icon' alt='group icon' src={GroupIcon}/> : <></>}
                  </div>
                )}
                {projects && 
                  <>
                    <div className='member-dropdown-info'>{member?.User?.Email || member?.Email}</div>
                    <div className='member-dropdown-info'>{member?.User?.Company?.Name}</div>
                  </>  
                }
              </div>
            </div>

          {(member.IsAssigned || member.CanEdit || member?.User?.CanEdit) && !filter || (member.permission === "edit") || (member.permission === "assign") ? (
            
            <div className='icon-permission-container'>
              <div className={`member-dropdown-row-edit-text-icon${""}`}>
                Edit
              </div>
            </div>
                        
          ) : (
            ""
          )}
          {((member.CanView || member?.User?.CanView) && !filter) || (member.permission === "view") ? (
            <div className='icon-permission-container'>
              {/* <div className={"member-dropdown-row-view-icon"}></div> */}
              <div className={"member-dropdown-row-view-text-icon"}>View</div>
            </div>
          ) : (
            ""
          )}
          {(member.CanApprove || member?.User?.CanApprove) && !filter || (member.permission === "approve") ? (
            <div className='icon-permission-container'>
              <div className={"member-dropdown-row-icon"}>Approve</div>
            </div>
          ) : (
            ""
          )}
          {member.CanPublish && !filter || (member.permission === "publish") ?  (
            <div className='icon-permission-container'>
              <div className={"member-dropdown-row-publish-text-icon"}>
                Publish
              </div>
            </div>
          ) : (
            ""
          )}
          {member.owner && !filter ? ( //--
            <div className='icon-permission-container'>
              {/* <div className={"member-dropdown-row-approve-icon"}></div> */}
              <div className={"member-dropdown-row-icon"}>Approve</div>
            </div>
          ) : (
            ""
          )}
        </Form.Check>
    </div>
  );
};

MemberDropdownNew.propTypes = {
  member: PropTypes.shape({
    Name: PropTypes.string,
    Email: PropTypes.string,
    Id: PropTypes.number,
    strRole: PropTypes.string,
    StrRole: PropTypes.string,
    Initials: PropTypes.string,
    GroupId : PropTypes.number,
    emailID : PropTypes.string,
    CanApprove: PropTypes.bool,
    CanEdit: PropTypes.bool,
    CanView: PropTypes.bool,
    IsAssigned: PropTypes.bool,
    permission : PropTypes.string,
    IsGroup: PropTypes.bool,
    IsOwner: PropTypes.bool,
    User: PropTypes.shape({
      Name: PropTypes.string.isRequired,
      Email: PropTypes.string.isRequired,
      Id: PropTypes.number.isRequired,
      strRole: PropTypes.string.isRequired,
      Initials: PropTypes.string.isRequired,
      CanApprove: PropTypes.bool,
      CanEdit: PropTypes.bool,
      CanView: PropTypes.bool,
      Company: PropTypes.shape({
        Name: PropTypes.string.isRequired,
        Id: PropTypes.number.isRequired,
      }),
      GroupMembers: PropTypes.arrayOf(PropTypes.shape({
        User: PropTypes.shape({
          Name: PropTypes.string.isRequired,
          Email: PropTypes.string.isRequired,
          Id: PropTypes.number.isRequired,         
        }),
      })),
    }),
  }).isRequired,
  isUserAdminComponent: PropTypes.bool.isRequired,
  isGroupOwner: PropTypes.bool.isRequired,
  isMultiOwner: PropTypes.bool,
  selectedMembers: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.number,
      UserId: PropTypes.number,
    })
  ),
  isGroupIcon: PropTypes.bool.isRequired,
};

export default MemberDropdownNew;
